import { applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import classActions from './Middlewares/classActions';

const composeEnhancers = composeWithDevTools({});

export default composeEnhancers(applyMiddleware(classActions));
